export enum ELegalCheckUpdateErrorMessages {
  /** Отличный от 200 ответ **/
  InvalidResponse = 'Bad update legal check response',
  /** Ошибка запроса **/
  ErrorRequest = 'Unable to update legal check request',
  /** Ошибка валидации **/
  ValidationError = 'Legal check form validation error',
  /** Сообщение об ошибке, которое будет показано пользователю **/
  GeneralError = 'Что-то пошло не так. Попробуйте еще раз, либо зайдите позже',
}
